var map = {
	"./RFID security gate.png": 3580,
	"./RFID security gate1.png": 9759,
	"./RFID security gate2.png": 8292,
	"./RFID security gate3.png": 9421,
	"./Staff station.png": 8604,
	"./Staff station1.png": 4687,
	"./Staff station2.png": 7828,
	"./barcode-scanner.png": 8395,
	"./barcode.png": 194,
	"./barcode1.png": 1713,
	"./barcode2.png": 634,
	"./biometric-face.png": 5932,
	"./biometric-fingerprint.png": 8227,
	"./bookdropbox.png": 5825,
	"./bookdropbox1.png": 6316,
	"./bookdropbox2.png": 3895,
	"./e-secure-smart-shelf.jpeg": 1987,
	"./gps-device.jpg": 3035,
	"./gps.png": 2350,
	"./gps1.png": 7173,
	"./gps2.png": 5374,
	"./gps3.png": 8391,
	"./ip camera.png": 7614,
	"./ip camera1.png": 117,
	"./ip camera2.png": 4366,
	"./ip-camera.png": 3707,
	"./issue-return.png": 1544,
	"./issuereturn.png": 293,
	"./issuereturn1.png": 984,
	"./kiosk.png": 2575,
	"./kiosk01.png": 2390,
	"./kiosk02.png": 4013,
	"./kiosk03.png": 4068,
	"./kiosk4.webp": 1325,
	"./rfid handle device.png": 6967,
	"./rfid handle device1.png": 6398,
	"./rfid handle device2.png": 405,
	"./rfid handle device3.png": 3868,
	"./rfid-handle-device.png": 1105,
	"./rfid-security-gate.png": 2762,
	"./rfid-smart-almirah.jpeg": 6483,
	"./rfid-smart-almirah.png": 3042,
	"./rfid-smart-almirah1.png": 2289,
	"./rfid-smart-card.jpeg": 2341,
	"./rfid-smart-card.png": 3896,
	"./rfid-smart-card1.png": 4051,
	"./rfid-smart-card2.png": 8440,
	"./rfid-tag.jpeg": 1449,
	"./rfid-tag.png": 6500,
	"./rfid-tag1.png": 9431,
	"./rfid-tag2.png": 8796,
	"./rommer.png": 5574,
	"./roombr.png": 925,
	"./roombr1.png": 5200,
	"./roombr2.png": 235,
	"./server room.png": 8192,
	"./server room1.png": 5083,
	"./server room2.png": 7520,
	"./server-room.png": 4897,
	"./smart class.png": 8165,
	"./smart class1.png": 3672,
	"./smart-class-monitor.png": 6007,
	"./solar camera.png": 9412,
	"./solar-camera.png": 6121,
	"./solarcamera1.png": 899,
	"./solarcamera2.png": 5144,
	"./staff-station.png": 5439,
	"./standy.png": 4301,
	"./standy1.png": 8992,
	"./standy2.png": 8843,
	"./uhf-rfid-flap-barrier.jpeg": 2658,
	"./uhf-rfid-flap-barrier.png": 8221,
	"./uhf-rfid-flap-barrier1.png": 5152,
	"./uhf-rfid-flap-barrier2.png": 2715,
	"./uhf-rfid-flap-barrier3.png": 1170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4905;